// Vortex tank — void portals + tentacle lash + anti-gravity beam

export const VORTEX = {
  // Portal placement
  PORTAL_MAX_ACTIVE: 2,              // only 2 portals at a time (one pair)
  PORTAL_LIFETIME_TURNS: 5,          // Vortex's own turns before expiry
  PORTAL_BEHIND_OFFSET: 40,          // px behind Vortex for second portal placement

  // Portal walk-through
  PORTAL_WALK_RADIUS: 20,            // must walk through center to teleport
  PORTAL_JUMP_SINK_FRAMES: 15,
  PORTAL_JUMP_EMERGE_FRAMES: 15,

  // Tentacle lash (proximity defense)
  TENTACLE_RANGE: 250,               // px — proximity trigger radius
  TENTACLE_DAMAGE: 12,               // % damage on lash
  TENTACLE_KB: 5.0,                  // knockback force
  TENTACLE_COOLDOWN: 90,             // frames per portal per enemy
  TENTACLE_ANIM_FRAMES: 20,          // visual lash animation duration

  // Collapse (S2 activation ability)
  COLLAPSE_GRAB_RANGE: 400,          // px — grab range from each portal
  COLLAPSE_PULL_FRAMES: 30,          // frames to pull enemy into portal
  COLLAPSE_LAUNCH_SPEED: 9.0,        // upward/outward launch velocity
  COLLAPSE_LAUNCH_ANGLE: -1.2,       // radians — upward bias (~70° from horizontal)
  COLLAPSE_DAMAGE: 20,               // % damage on collapse launch
  COLLAPSE_CARVE_RADIUS: 25,         // terrain carve at portal on collapse

  // Capture immunity (after portal events)
  CAPTURE_IMMUNITY_FRAMES: 90,       // cooldown after tentacle lash
} as const;
